const TokenKey = 'token'

/**
 * 获取token
 * @return {string}
 */
export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

/**
 * 设置token，为空时移除token
 * @param {string} [token]
 */
export function setToken(token) {
  token ? sessionStorage.setItem(TokenKey, token) : sessionStorage.removeItem(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js